/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { _finally as _finallyOperator } from 'rxjs/operator/finally';
import { _catch as _catchOperator } from 'rxjs/operator/catch';
import { _do as _doOperator } from 'rxjs/operator/do';
import { map as mapOperator } from 'rxjs/operator/map';
import { filter as filterOperator } from 'rxjs/operator/filter';
import { share as shareOperator } from 'rxjs/operator/share';
import { first as firstOperator } from 'rxjs/operator/first';
import { switchMap as switchMapOperator } from 'rxjs/operator/switchMap';
import { startWith as startWithOperator } from 'rxjs/operator/startWith';
import { debounceTime as debounceTimeOperator } from 'rxjs/operator/debounceTime';
import { auditTime as auditTimeOperator } from 'rxjs/operator/auditTime';
import { takeUntil as takeUntilOperator } from 'rxjs/operator/takeUntil';
import { delay as delayOperator } from 'rxjs/operator/delay';
export class FinallyBrand {
}
function FinallyBrand_tsickle_Closure_declarations() {
    /** @type {?} */
    FinallyBrand.prototype._;
}
export class CatchBrand {
}
function CatchBrand_tsickle_Closure_declarations() {
    /** @type {?} */
    CatchBrand.prototype._;
}
export class DoBrand {
}
function DoBrand_tsickle_Closure_declarations() {
    /** @type {?} */
    DoBrand.prototype._;
}
export class MapBrand {
}
function MapBrand_tsickle_Closure_declarations() {
    /** @type {?} */
    MapBrand.prototype._;
}
export class FilterBrand {
}
function FilterBrand_tsickle_Closure_declarations() {
    /** @type {?} */
    FilterBrand.prototype._;
}
export class ShareBrand {
}
function ShareBrand_tsickle_Closure_declarations() {
    /** @type {?} */
    ShareBrand.prototype._;
}
export class FirstBrand {
}
function FirstBrand_tsickle_Closure_declarations() {
    /** @type {?} */
    FirstBrand.prototype._;
}
export class SwitchMapBrand {
}
function SwitchMapBrand_tsickle_Closure_declarations() {
    /** @type {?} */
    SwitchMapBrand.prototype._;
}
export class StartWithBrand {
}
function StartWithBrand_tsickle_Closure_declarations() {
    /** @type {?} */
    StartWithBrand.prototype._;
}
export class DebounceTimeBrand {
}
function DebounceTimeBrand_tsickle_Closure_declarations() {
    /** @type {?} */
    DebounceTimeBrand.prototype._;
}
export class AuditTimeBrand {
}
function AuditTimeBrand_tsickle_Closure_declarations() {
    /** @type {?} */
    AuditTimeBrand.prototype._;
}
export class TakeUntilBrand {
}
function TakeUntilBrand_tsickle_Closure_declarations() {
    /** @type {?} */
    TakeUntilBrand.prototype._;
}
export class DelayBrand {
}
function DelayBrand_tsickle_Closure_declarations() {
    /** @type {?} */
    DelayBrand.prototype._;
}
// We add `Function` to the type intersection to make this nomically different from
// `finallyOperatorType` while still being structurally the same. Without this, TypeScript tries to
// reduce `typeof _finallyOperator & FinallyBrand` to `finallyOperatorType<T>` and then fails
// because `T` isn't known.
export const /** @type {?} */ finallyOperator = (_finallyOperator);
export const /** @type {?} */ catchOperator = (_catchOperator);
export const /** @type {?} */ doOperator = (_doOperator);
export const /** @type {?} */ map = (mapOperator);
export const /** @type {?} */ filter = (filterOperator);
export const /** @type {?} */ share = (shareOperator);
export const /** @type {?} */ first = (firstOperator);
export const /** @type {?} */ switchMap = (switchMapOperator);
export const /** @type {?} */ startWith = (startWithOperator);
export const /** @type {?} */ debounceTime = (debounceTimeOperator);
export const /** @type {?} */ auditTime = (auditTimeOperator);
export const /** @type {?} */ takeUntil = (takeUntilOperator);
export const /** @type {?} */ delay = (delayOperator);
//# sourceMappingURL=rx-operators.js.map